import { DateInputFormats, DateInputParsings, DateInputPlaceholders } from './DatePickerEnums';
import { DatePickerDefaultLabels, DatePickerInputFormat } from './DatePickerTypes';

export const datePickerInputFormats: DatePickerInputFormat[] = [
  {
    format: DateInputFormats.DMY,
    parse: DateInputParsings.DMY,
    placeholder: DateInputPlaceholders.DMY
  },
  {
    format: DateInputFormats.MDY,
    parse: DateInputParsings.MDY,
    placeholder: DateInputPlaceholders.MDY
  },
  {
    format: DateInputFormats.YMD,
    parse: DateInputParsings.YMD,
    placeholder: DateInputPlaceholders.YMD
  }
];

export const datePickerIsoFormat = 'yyyy-MM-dd'; // 2021-12-31

export const datePickerNumberOfDays = 7;


export const datePickerDefaultLabels = (translationCallback: (copy: string) => string): DatePickerDefaultLabels => ({
  invalidDateError: translationCallback('Invalid date!'),
  labelCalendarIconButton: translationCallback('Choose date. Selected date:'),
  labelCloseButton: translationCallback('Close'),
  labelNextMonthButton: translationCallback('Next month'),
  labelNextYearButton: translationCallback('Next year'),
  labelPreviousMonthButton: translationCallback('Previous month'),
  labelPreviousYearButton: translationCallback('Previous year'),
  labelTextfield: translationCallback('Date'),
  labelToday: translationCallback('Today'),
});
